module.exports = __webpack_public_path__ + "static/media/sell_report_deal_3.317dd06d.png";